<!--
@Create By Tim For 19/08/
@
-->
<template>
  <div class="Login">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="登录"
      :center="true"
      :visible.sync="dialogFormVisible"
      width="18%"
    >
      <el-form
        :model="form"
        :rules="rule"
        ref="form"
      >
        <el-form-item
          label="账号："
          label-width="80"
          prop="name"
        >
          <el-input
            class="loginInput"
            v-model.trim="form.name"
          />
        </el-form-item>
        <el-form-item
          label="密码："
          label-width="80"
          prop="password"
        >
          <el-input
            type="password"
            class="loginInput"
            v-model.trim="form.password"
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="login"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Bus from '../../bus'
import api from '../../../config/api'
export default {
  name: 'Login',
  data() {
    return {
      // 是否弹出登录窗口
      dialogFormVisible: false,
      // 登录窗口表单对象
      form: {
        name: '',
        password: '',
      },
      rule: {
        name: [
          { required: true, message: '请输入工号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
    }
  },

  created() {
    this.monitorLogin()
  },


  methods: {
    // 打开登录窗
    openDialog() {
      this.dialogFormVisible = true
    },

    // 监听是否需要打开登录窗口
    monitorLogin() {
      Bus.$on('openLoginDialog', data => {
        this.dialogFormVisible = true
      })
    },

    // 登录提交
    login() {
      let data = {
        loginName: this.form.name,
        password: this.form.password
      }
      this.$axios.post(
        api + 'accounts/token',
        data
      ).then(res => {
        this.dialogFormVisible = false
        this.$notify({
          title: '登录成功',
          type: 'success',
          offset: 100
        })
        window.sessionStorage.setItem('userInfo', JSON.stringify(res))
        Bus.$emit('loginSuccess', res)
      })
    },

    // 取消关闭
    close() {
      this.$refs.form.resetFields()
      this.dialogFormVisible = false
    },


  },


}
</script>
<style>
.Login .el-dialog {
  width: 345px !important;
}

.Login .el-form-item__error {
  left: 65px;
}
</style>


<style scoped>
.Login .loginInput {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue